import { baseApi } from '@ibk/shared-config';
import { getSelectedAccountInfo } from '@ibk/shared-auth';
const transformApiResponse = (apiResponse) => {
    const featureFlags = apiResponse.result.map((item) => ({
        useCase: item.usecase,
        state: item.state,
        whitelistedUsers: [],
        blacklistedUsers: [],
        enabled: item.state === 'WHITELISTED',
        metadata: {
            id: item.id,
            name: item.name,
            originalUsecase: item.usecase,
        },
    }));
    return {
        featureFlags,
        version: '1.0.0',
        timestamp: new Date().toISOString(),
    };
};
export const featureFlagsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getFeatureFlags: builder.query({
            query: (scope) => {
                const partyId = scope?.partyId ?? getSelectedAccountInfo()?.targetId;
                return {
                    url: '/v1/feature-flags',
                    ...(partyId && { headers: { 'x-tr-party-selected': partyId } }),
                };
            },
            providesTags: ['FeatureFlags'],
            transformResponse: (response) => {
                const transformedResponse = transformApiResponse(response);
                return transformedResponse;
            },
            transformErrorResponse: (response) => {
                return response;
            },
        }),
    }),
    overrideExisting: false,
});
export const { useGetFeatureFlagsQuery, useLazyGetFeatureFlagsQuery } = featureFlagsApi;
